/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const integrationScheduleResponseSchema = z.object({
  cadence: z.enum(['30m', '60m']),
  pull: z.boolean(),
  push: z.boolean(),
});
